import { Component, HostBinding, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedModule } from '../../../shared/shared.module';
import { PageTitleDirective } from '../../directives/page-title.directive';
import { StateService } from '../../services/state.service';

@Component({
    selector: 'app-initialization',
    templateUrl: './initialization.component.html',
    styleUrls: ['./initialization.component.scss'],
  imports: [SharedModule, PageTitleDirective, TranslatePipe]
})
export class InitializationComponent {

  private readonly stateService = inject(StateService);

  @HostBinding('class')
  protected get layoutClass() {
    return `full-height-stack center flow-center`;
  }

  constructor() {
    this.stateService.initialize();
  }

}
